import { ExtraServiceResponse } from '..';

export const EXTRA_SERVICE_INIT: ExtraServiceResponse = {
	data: [],
};
